/**
 * Web Style Import
 *
 */

import './style/dnb-height-animation.scss'
